import { useTranslation } from 'helpers/hooks/useTranslation'
import { useRouter } from 'helpers/navigation'
import React from 'react'
import styled from 'styled-components'
import { complementaryColor } from 'uiComponents/constants/colors'
import { fsXXXXL, fwBold } from 'uiComponents/constants/typography'
import {
  ImgBackdrop,
  StoryDiscover,
  StoryIntroduction,
} from './StoryHeaderImage'

const Wrapper = styled.a`
  position: relative;
  height: 50vw;
  min-height: 375px;
  max-height: 640px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  background: #e1e1e1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Title = styled.span`
  ${fwBold};
  color: ${complementaryColor};
  font-size: ${fsXXXXL}px;
  text-align: center;
  margin: 24px 0 50px;
  padding: 0 8px;
`

const TextWrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1;
`

const BackgroundImage = styled.div<{ image: string }>`
  width: 100%;
  height: 100%;
  background-image: url(${props => props.image});
  background-position: top;
`

const BackgroundWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

interface IProps {
  storyName: string
  storyImageSrc: string
  storyHref: string
}

const StaticStoryHeaderImage: React.FC<IProps> = props => {
  const { storyName, storyHref, storyImageSrc } = props
  const { t } = useTranslation()
  const { navigateClient } = useRouter()

  return (
    <Wrapper href={storyHref} onClick={navigateClient(storyHref)}>
      <BackgroundWrapper>
        <BackgroundImage image={storyImageSrc} />
        <ImgBackdrop />
      </BackgroundWrapper>
      <TextWrapper>
        <StoryIntroduction>
          {t('Passende Inspiration für dich')}
        </StoryIntroduction>
        <Title>{storyName}</Title>
        <StoryDiscover>{t('Mehr entdecken')}</StoryDiscover>
      </TextWrapper>
    </Wrapper>
  )
}

export default StaticStoryHeaderImage
